import React, { useEffect, useMemo, useState } from "react";
import Checkbox from "../../common/Form/Checkbox";
import DatePicker from "../../common/Form/DatePicker";
import Upload from "../../common/Form/FileUpload";
import Input from "../../common/Form/Input";
import { RangeSelector } from "../../common/Form/RangeSelector";
import Select from "../../common/Form/Select";
import { useDispatch } from "react-redux";
import { aadharKycSendOtp, aadharKycVerifyOtp, postImageUrl, setInviteFormCreatedUserId, verifyPancard } from "../../actions/users";
import { getNewAuthToken, getOrgId } from "../../utils/common";
import config from "../../config";
import { useSelector } from "react-redux";
import { DROPDOWN_LOAD_SUCCESS } from "../../types/utils";
import _ from "lodash";
import Form from "../../common/Form";
import { useForm, useFormContext } from "react-hook-form";
import { closeModalAction } from "../../actions/modal";
import axiosInstance from "../../apis/axios";
import Address from "../../components/Inputs/Address";
import MultipleDomains from "../../common/Form/MultipleDomains";
import { PAN_OR_AADHAR_LOADING } from "../../types/loading";
import { onboardPath, sendInvitePath } from "../../router/roleWisePageRoute";
import moment from "moment";


export function normalizeDate(value) {
    if (moment(value, "YYYY-MM-DD", true).isValid()) {
        return moment(value, "YYYY-MM-DD").format("YYYY-MM-DD")
    }
    if (moment(value, "DD-MM-YYYY", true).isValid()) {
        return moment(value, "DD-MM-YYYY").format("YYYY-MM-DD")
    }
    return null
}


export const fieldTypes = {
    DATE: 'DATE',
    TEXT: 'TEXT',
    AADHAR: "AADHAR",
    PAN: "PAN",
    IMG: "IMG",
    EMAIL: "EMAIL",
    GST: "GST",
    IFSC: "IFSC",
    PHONE: "PHONE",
    REGEX: "REGEX",
    BANK: "BANK",
    CHECK_BOX: "CHECK_BOX",
    MENU: "MENU",
    MULTI_MENU: "MULTI_MENU",
    SLIDER: "SLIDER",
    BANK_ACC_NUM: 'BANK_ACC_NUM',
    ADDRESS: 'ADDRESS',
    DOMAIN: 'DOMAIN'
}

const isCriteriaMet = (id, value) => {
    const newId = `${id}::${value}`;
    const element = document.getElementById(newId);
    return element?.checked?.toString() === "true";
}

export const ParsedInput = ({ field, type, onChange = () => { }, iconRight, disabled }) => {

    if (field?.enable_criteria.length > 0) {
        const hasCriteriaMet = field.enable_criteria.some(e => isCriteriaMet(e.linked_ref, e.value));
        if (!hasCriteriaMet) return null;
    }

    return (
        <div className="w-full">
            <Input
                shouldUnregister
                onChange={onChange}
                type={type}
                id={field.ref}
                label={field.label}
                required={field.required}
                name={field.ref}
                validate={(value) => {
                    if (!value) return true;
                    if (field.regex) {
                        return new RegExp(field.regex).test(value) || 'Invalid';
                    }
                    return true;
                }}
                iconRight={iconRight ? iconRight : null}
                readOnly={disabled}
            />
        </div>
    );
}

export const createApiUrl = (apiData) => {
    const { module, path } = apiData;
    const modulePath = module.toLowerCase();
    let base_url = config.api.scogoApiUrl;

    let finalPath = path;

    if (finalPath.includes('limit=')) {
        finalPath = finalPath.replace(/limit=\d+/i, 'limit=100');
    } else {
        if (finalPath.includes('?')) {
            finalPath += '&limit=100';
        } else {
            finalPath += '?limit=100';
        }
    }

    return `${base_url}/${modulePath}/${finalPath}`;
};


const ParsedSelect = ({ field, isMulti }) => {
    const dropDownOptionsData = useSelector(state => state.utils.dropDownOptionsData);
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { setValue } = useFormContext();

    const options = useMemo(() => {
        let options = [];
        if (field.options && field.options.length > 0) {
            options = field.options.map((elem) => ({ ...elem, key: elem.value }));
        } else {
            let o = dropDownOptionsData[field.ref] || [];
            o = o.map(e => {
                let b = { ...e, key: e.value };
                if (!b.value && b.id) b.value = b.id;
                if (!b.label && b.name) b.label = b.name;
                return b;
            });
            options = o;
        }
        if (options.length === 1 && newLoggedUserData.org.id === options[0].value) {
            if (field.data_type === 'MULTI_MENU') {
                setValue(field.ref, [options[0]], { shouldValidate: true, shouldDirty: true });
            } else {
                setValue(field.ref, options[0], { shouldValidate: true, shouldDirty: true });
            }
        }
        return options;
    }, [dropDownOptionsData, field.ref, field.options, newLoggedUserData.org.id]);

    const getOptions = useMemo(() => {
        const debouncedFetch = _.debounce(async (query = '') => {
            const apiData = field.cta && field.cta.find(e => e.call_on === "LOAD");
            try {
                setIsLoading(true);
                const response = await axiosInstance.get(createApiUrl(apiData), {
                    params: { q: query || undefined },
                    headers: {
                        'x-org-id': getOrgId(),
                        'authorization': `Bearer ${getNewAuthToken()}`
                    }
                });

                const responseData = response?.data?.data;
                if (responseData?.length > 0) {
                    dispatch({ type: DROPDOWN_LOAD_SUCCESS, payload: { ref: field.ref, data: responseData } });
                }
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
            setIsLoading(false);
        }, 300);

        return debouncedFetch;
    }, [dispatch, field.cta, field.ref]);

    useEffect(() => {
        getOptions();
    }, [getOptions]);

    if (field?.enable_criteria.length > 0) {
        const hasCriteriaFailed = field.enable_criteria.some(e => !isCriteriaMet(e.linked_ref, e.value));
        if (hasCriteriaFailed) return null;
    };

    return (
        <div className="w-full">
            <Select
                id={field.ref}
                label={field.label}
                name={field.ref}
                required={field.required}
                options={options}
                isMulti={isMulti}
                onInputChange={(q) => {
                    if (q) getOptions(q);
                }}
                isLoading={isLoading}
                findOption={(options, value) => {
                    // return options.filter(opt => {
                    //     return value.find((e => e.value === opt.value));
                    // });
                }}
                readOnly={options.length === 1 && newLoggedUserData.org.id === options[0].value}
            />
        </div>
    );
};

export default ParsedSelect;

export const ParsedCheckBox = ({ field, fieldClass = '' }) => {
    const { watch } = useFormContext();
    if (field?.enable_criteria.length > 0) {
        const hasCriteriaFailed = field.enable_criteria.some(e => !isCriteriaMet(e.linked_ref, e.value));
        if (hasCriteriaFailed) return null;
    }

    const values = watch();

    // Check if any checkbox in this group is selected
    const isAnySelected = field.options.some(({ value }) =>
        values[`${field.ref}::${value}`]
    );

    return (
        <div className={`w-full ml-2 flex items-center gap-2 ${fieldClass}`}>
            <div>{field.label}</div>
            {field.options.map(({ label, value }) => {
                return <Checkbox
                    key={value}
                    shouldUnregister
                    id={`${field.ref}::${value}`}
                    label={label}
                    name={`${field.ref}::${value}`}
                    required={field.required && !isAnySelected} // Required only if none are selected
                />
            })}
        </div>
    );
};

const RenderAadharInput = ({ field, typeEnum }) => {
    const dispatch = useDispatch();
    const kycAadharData = useSelector((state) => state.user.kycAadharData);
    const { setValue } = useFormContext();
    const [iconRight, setIconRight] = useState(null);

    useEffect(() => {
        if (kycAadharData && kycAadharData.data) {
            if (kycAadharData.data.full_name) setValue('full_name', kycAadharData.data.full_name);
            if (kycAadharData.data.gender) setValue('gender', kycAadharData.data.gender);
            if (kycAadharData.data.dob) {
                const date = normalizeDate(kycAadharData.data.dob);
                if (date) setValue('dob', new Date(date));
            }
            if (kycAadharData.data.address) setValue('work_center_coords', kycAadharData.data.address);
            // if (kycAadharData.data.aadhaar) setValue('kyc_aadhar', kycAadharData.data.aadhaar);
            setIconRight({ hoverTitle: 'Aadhar Verified', name: <span className='text-whatsappGreen  max-w-[1rem]'>✅</span> });
        } else {
            setIconRight(null);
        }
    }, [kycAadharData, setValue]);

    const onChange = (event) => {
        if (typeEnum === 'INVITE') return;
        if (new RegExp(field.regex).test(event.target.value)) {
            dispatch(aadharKycSendOtp({ aadhar: event.target.value }));
        }
    };

    const isDisabled = window.location.pathname === onboardPath.path;
    return <ParsedInput disabled={isDisabled} field={field} type="text" onChange={onChange} iconRight={iconRight} />;
}

export const VerifyAadharOtp = ({ clientId }) => {
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);
    const formName = 'kycVerifyAadharOtp';
    const onSubmit = ({ otp }) => {
        dispatch(aadharKycVerifyOtp({ clientId, otp, formName }));
    };

    const methods = useForm({ defaultValues: {}, mode: 'all' });

    return <div>
        <Form methods={methods}
            onSubmit={onSubmit}
            submitButtonText={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <Input type="text" label='Enter OTP' name='otp' />
        </Form>
    </div>
}

export const RenderPancardInput = ({ field, typeEnum }) => {
    const dispatch = useDispatch();
    const kycPancardData = useSelector((state) => state.user.kycPancardData);
    const [iconRight, setIconRight] = useState(null);

    useEffect(() => {
        if (kycPancardData && kycPancardData.data) {
            setIconRight({ hoverTitle: 'Pancard Verified', name: <span className='text-whatsappGreen  max-w-[1rem]'>✅</span> });
        } else {
            setIconRight(null);
        }
    }, [kycPancardData]);

    const onChange = (event) => {
        if (typeEnum === 'INVITE') return;
        const uppercaseValue = event.target.value.toUpperCase();
        event.target.value = uppercaseValue;

        if (new RegExp(field.regex).test(uppercaseValue)) {
            dispatch(verifyPancard({ pancard: uppercaseValue }));
        }
    }
    const isDisabled = window.location.pathname === onboardPath.path;
    return <ParsedInput disabled={isDisabled} field={field} type="text" onChange={onChange} iconRight={iconRight} />;
}

export const GetInputElementFromObject = ({ field, fieldClass, user_id, typeEnum }) => {
    const { setValue } = useFormContext();
    const inviteFormCreatedUserId = useSelector((state) => state.user.inviteFormCreatedUserId);
    const inputTypes = useMemo(() => ({
        alphaNumeric: [fieldTypes.TEXT, fieldTypes.ADDRESS, fieldTypes.PAN, fieldTypes.GST, fieldTypes.BANK, fieldTypes.ADDRESS],
        numeric: [fieldTypes.AADHAR, fieldTypes.PHONE, fieldTypes.CONFIRM, fieldTypes.PINCODE, fieldTypes.BANK_ACC_NUM],
        img: [fieldTypes.IMG],
        email: [fieldTypes.EMAIL],
        date: [fieldTypes.DATE],
        checkBox: [fieldTypes.CHECK_BOX],
        selectMulti: [fieldTypes.MULTI_MENU],
        select: [fieldTypes.MENU],
        slider: [fieldTypes.SLIDER],
        domain: [fieldTypes.DOMAIN]
    }), []);

    const dispatch = useDispatch();
    const existingImageUrl = useSelector((state) => state.user.inviteFormImagesUrls[field?.ref]) || field?.link;

    const onSuccess = async (file_url, createdUserId) => {
        if (typeEnum === 'INVITE' && createdUserId) {
            dispatch(setInviteFormCreatedUserId(createdUserId));
        }
        try {
            dispatch({ type: PAN_OR_AADHAR_LOADING, payload: true });
            if (field.ref === 'kyc-aadhar-front' || field.ref === 'kyc-pancard-front') {
                const response = await axiosInstance.post(
                    `${config.api.streamV2ApiUrl}/utils/extractor-kyc`,
                    {
                        file_url,
                        event_type: "KYC",
                        user_id
                    },
                    {
                        headers: {
                            'x-org-id': getOrgId(),
                            'authorization': `Bearer ${getNewAuthToken()}`
                        }
                    }
                );
                const data = response?.data?.data;
                if (field.ref === 'kyc-aadhar-front' && data) {
                    if (data.is_valid_adhaar && data.adhaar_number) {

                        const formattedAadhar = data.adhaar_number.replace(/\s+/g, '');
                        setValue('kyc-aadhar', formattedAadhar, { shouldValidate: true, shouldDirty: true });
                        if (formattedAadhar && new RegExp(field.regex).test(formattedAadhar)) {
                            dispatch(aadharKycSendOtp({ aadhar: formattedAadhar }));
                        }
                    } else {
                        dispatch({
                            type: 'toast',
                            payload: {
                                message: 'Unable to fetch Aadhar details. Please try again later.',
                                type: 'error'
                            }
                        })
                    }
                }

                if (field.ref === 'kyc-pancard-front' && data) {
                    if (data.is_valid_pan && data.pan_number) {
                        setValue('kyc-pancard', data.pan_number, { shouldValidate: true, shouldDirty: true });
                        dispatch(verifyPancard({ pancard: data.pan_number }));
                    } else {
                        dispatch({
                            type: 'toast',
                            payload: {
                                message: 'Unable to fetch PAN details. Please try again later.',
                                type: 'error'
                            }
                        })
                    }
                }
            }
        } catch (error) {
            console.log('Error in KYC extraction:', error);
        }
        dispatch({ type: PAN_OR_AADHAR_LOADING, payload: false });
    };

    const onFileUpload = (files, ref) => {
        let purpose = '';
        if (ref === 'avatar_link') purpose = 'AVATAR';
        else if (ref === 'kyc-aadhar-front') purpose = 'USER_AADHAAR';
        else if (ref === 'kyc-aadhar-back') purpose = 'USER_AADHAAR';
        else if (ref === 'kyc-pancard-front') purpose = 'USER_PANCARD';
        else if (ref === 'kyc-pancard-back') purpose = 'USER_PANCARD';

        let effectiveUserId = user_id;
        let additionalData = { user_id: user_id };
        if (typeEnum === 'INVITE') {
            effectiveUserId = inviteFormCreatedUserId || undefined;
            additionalData = inviteFormCreatedUserId ? {} : { create: true };
        }

        dispatch(postImageUrl({ files, ref, purpose, user_id: effectiveUserId, additionalData, onSuccess, panOrAadharUpload: true }));
    }

    if (field?.data_type === fieldTypes.DOMAIN) {
        return <MultipleDomains
            shouldUnregister
            id={field.ref}
            label={field.label}
            required={field.required}
            name={field.ref}
        />;
    }

    if (!field?.data_type) {
        return <ParsedInput field={field} type="text" />;
    }

    const { data_type, ref } = field;

    if (ref === 'kyc-aadhar') {
        return <RenderAadharInput typeEnum={typeEnum} field={field} fieldClass={fieldClass} onFileUpload={onFileUpload} />;
    }

    if (ref === 'kyc-pancard') {
        return <RenderPancardInput typeEnum={typeEnum} field={field} fieldClass={fieldClass} onFileUpload={onFileUpload} />;
    }

    if (data_type === fieldTypes.ADDRESS) {
        return <Address className={fieldClass} id={field.ref} name={field.ref} label={field.label} required={field.required} />;
    }

    if (ref === 'avatar_link') {
        return <div className="w-full px-1">
            <Upload
                id={field.ref}
                label={field.label}
                name={field.ref}
                required={field.required}
                padding=""
                onChange={e => onFileUpload(e, field.ref)}
                accept="image/jpeg,image/png"
                validateFileType={file => {
                    const isImage = ['image/jpeg', 'image/png'].includes(file.type);
                    return isImage || `${file.name} is not an image`;
                }}
            />
        </div>
    }

    if (inputTypes.checkBox.includes(data_type)) {
        return <ParsedCheckBox fieldClass={fieldClass} field={field} />;
    }

    if (inputTypes.alphaNumeric.includes(data_type)) {
        return <ParsedInput field={field} type="text" />;
    }

    if (inputTypes.numeric.includes(data_type)) {
        return <ParsedInput field={field} type="number" />;
    }

    if (inputTypes.email.includes(data_type)) {
        return <ParsedInput field={field} type="email" />;
    }

    if (inputTypes.select.includes(data_type)) {
        return <ParsedSelect field={field} isMulti={false} />;
    }

    if (inputTypes.selectMulti.includes(data_type)) {
        return <ParsedSelect field={field} isMulti={true} />;
    }

    if (inputTypes.slider.includes(data_type)) {
        return (
            <div className="w-full">
                <RangeSelector
                    id={field.ref}
                    label={field.label}
                    name={field.ref}
                    required={field.required}
                    min={+field.range.min}
                    max={+field.range.max}
                    metric='km'
                    value={5}
                />
            </div>
        );
    }

    if (inputTypes.date.includes(data_type)) {
        return (
            <div className="w-full px-1">
                <DatePicker
                    shouldUnregister
                    id={field.ref}
                    label={field.label}
                    name={field.ref}
                    required={field.required}
                    placeholder="dd/mm/yyyy"
                    padding=""
                    dateClassName="mt-2"
                />
            </div>
        );
    }

    if (inputTypes.img.includes(data_type)) {
        return (
            <div className="w-full px-1">
                <Upload
                    id={field.ref}
                    label={field.label}
                    name={field.ref}
                    required={field.required && !existingImageUrl}
                    existingFileUrl={existingImageUrl}
                    padding=""
                    onChange={e => onFileUpload(e, field.ref)}
                    accept="image/jpeg,image/png"
                    validateFileType={file => {
                        const isImage = ['image/jpeg', 'image/png'].includes(file.type);
                        return isImage || `${file.name} is not an image`;
                    }}
                />
            </div>
        );
    }

    return null;
}
